/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerSubmission } from '../../models/customer-submission';
import { CustomerSubmissionForm } from '../../models/customer-submission-form';

export interface CreateDkvCustomer$Params {

/**
 * UUID to identify the svg (tenancy id)
 */
  svgId: string;

/**
 * UUID to identify the customer
 */
  customerId: string;
      body: CustomerSubmissionForm
}

export function createDkvCustomer(http: HttpClient, rootUrl: string, params: CreateDkvCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerSubmission>> {
  const rb = new RequestBuilder(rootUrl, createDkvCustomer.PATH, 'post');
  if (params) {
    rb.path('svgId', params.svgId, {});
    rb.path('customerId', params.customerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerSubmission>;
    })
  );
}

createDkvCustomer.PATH = '/svgs/{svgId}/customers/{customerId}/dkv-customer-submission';
